import { NgModule } from '@angular/core';
import { SharedModule } from 'src/app/shared/shared.module';
import { CookieService } from 'ngx-cookie-service';
import { ListUserMessagingComponent } from './mobile/list-user-messaging/list-user-messaging.component';
import { UserConversationComponent } from './mobile/user-conversation/user-conversation.component';
import { NewConversationComponent } from './mobile/new-conversation/new-conversation.component';
import { MessagerieComponent } from './messagerie.component';
import { MobileMessagerieComponent } from './mobile/mobile-messagerie/mobile-messagerie.component';
import { BrowserMessagerieComponent } from './browser/browser-messagerie/browser-messagerie.component';
import { AddConversationComponent } from './browser/add-conversation/add-conversation.component';

@NgModule({
	declarations: [
		MessagerieComponent,
		ListUserMessagingComponent,
		NewConversationComponent,
		UserConversationComponent,
		MobileMessagerieComponent,
		BrowserMessagerieComponent,
  AddConversationComponent
	],
	imports: [SharedModule],
	providers: [CookieService]
})
export class MessagerieModule {}
